import { render, staticRenderFns } from "./Application.vue?vue&type=template&id=38eccea6&scoped=true&"
import script from "./Application.vue?vue&type=script&lang=ts&"
export * from "./Application.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38eccea6",
  null
  
)

export default component.exports